import { get } from 'lodash';
import { getState } from '~src/state';

/**
 * Gets the multiplier value, prioritizing format-specific multiplier over project type multiplier.
 * @returns {number} The multiplier value (format multiplier > type multiplier > 1)
 */
export const getMultiplier = () => {
  const format = getState('selected.formato');
  const projectType = getState('selected.tipo');

  // Prioritize format-specific multiplier if defined
  if (format?.multiplier != null) {
    return format.multiplier;
  }

  // Fall back to project type multiplier
  if (projectType?.multiplier != null) {
    return projectType.multiplier;
  }

  // Default to 1
  return 1;
};

export const getFormatName = (canvas) => {
  const defaultName = get(
    canvas,
    'editor_project_formats_default_pointer.name'
  );
  if (defaultName) {
    return defaultName;
  }

  const customName = get(canvas, 'editor_project_formats_pointer.name');
  if (customName) {
    return customName;
  }

  return '';
};

export const getOrientationName = (canvas) => {
  const translationMap = {
    h: 'Orizzontale',
    v: 'Verticale',
  };
  const defaultName = get(
    canvas,
    'editor_project_formats_default_pointer.orientation'
  );
  if (defaultName) {
    return translationMap[defaultName];
  }

  const customName = get(canvas, 'editor_project_formats_pointer.orientation');
  if (customName) {
    return translationMap[customName];
  }

  return '';
};
